import { applyMiddleware, createStore } from 'redux';
import ReduxThunk from 'redux-thunk'

import reducer from '../redux/reducers';

const middleware = applyMiddleware(ReduxThunk)

export default createStore(reducer, middleware)


// WEBPACK FOOTER //
// ./src/redux/store.js